export default ({ predicate, intervalDuration=500 }) => new Promise(resolve => {
  const result = predicate()
  if (result) {
    resolve(result)
  } else {
    const interval = setInterval(
      () => {
        const result = predicate()
        if (result) {
          clearInterval(interval)
          resolve(result)
        }
      }
    , intervalDuration)
  }
  return
})
